<template>
  <div class="burger-menu" :class="{ 'open': isOpen }">
    <div class="burger-menu-content">
      <router-link to="/" class="burger-menu-item">🏠 Home</router-link>
      <router-link to="/courses" class="burger-menu-item">📚 Courses</router-link>
      <router-link to="/tutorials" class="burger-menu-item">📝 Tutorials</router-link>
      <router-link to="/prompt" class="burger-menu-item">🦾 Prompt</router-link>
      <template v-if="!currentUser">
        <router-link to="/login" class="burger-menu-item">🔑 Login</router-link>
        <router-link to="/register" class="burger-menu-item">👤 Register</router-link>
      </template>
    </div>
  </div>
</template>

<script>
import {ref, watch, onMounted, onUnmounted} from "vue";
import { mapState } from 'vuex'

export default {
  name: "BurgerMenu",
  props: {
    isOpen: Boolean,
  },
  setup(props) {
    const isSubmenuOpen = ref(false);

    const toggleSubmenu = () => {
      isSubmenuOpen.value = !isSubmenuOpen.value;
    };

    watch(
        () => props.isOpen,
        (newVal) => {
          if (newVal) {
            document.body.style.overflow = "hidden";
          } else {
            document.body.style.overflow = "";
          }
        }
    );

    onUnmounted(() => {
      document.body.style.overflow = "";
    });

    return {
      isSubmenuOpen,
      toggleSubmenu,
    };
  },
  computed: {
    ...mapState({
      currentUser: state => state.auth.user
    })
  },
};
</script>

<style scoped>
.burger-menu {
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  width: 100%;
  height: calc(100vh - 60px);
  background: rgba(31, 31, 31, 0.98);
  backdrop-filter: blur(10px);
  z-index: 1000;
  transform: translateX(100%);
  transition: transform 0.3s ease;
}

.burger-menu.open {
  transform: translateX(0);
}

.burger-menu-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.burger-menu-item {
  display: flex;
  align-items: center;
  gap: 15px;
  color: var(--my-white);
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 10px;
  transition: all 0.3s ease;
  opacity: 0.8;
  cursor: pointer;
}

.burger-menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
  opacity: 1;
}

@media (max-width: 768px) {
  .burger-menu {
    display: block;
  }

  .burger-menu.open {
    transform: translateX(0);
  }
}
</style>
